import client from '/src/services/client.js';

export default {
    getChannels: (bot, data) => client.get(`analytics/${bot}/info/channels`, data),
    getAnalytics : (bot, data) => client.get(`analytics/${bot}/info/all/analytics`, data),
    getMetrics : (bot, data) => client.get(`analytics/${bot}/info/all/metrics`, data),
    getPeakActivity : (bot, data) => client.get(`analytics/${bot}/info/peak_conv_activity`, data),
    getRedirection : (bot, data) => client.get(`analytics/${bot}/info/redirection`, data),
    deleteAll : (bot, data, channel_id) => client.delete(`analytics/${bot}/info/all`, {...data, channel_id}),
    getCall : (bot, data) => client.get(`analytics/${bot}/info/call`, data),
    getCumulatedStats : (bot, data) => client.get(`analytics/${bot}/info/cumulated`, data),
    getNumOfCall : (bot, data) => client.get(`analytics/${bot}/info/num_call`, data),
    getNumOfConv : (bot, data) => client.get(`analytics/${bot}/info/num_conv`, data),
}
